export function isRarTypeUtils(fileName: string): boolean {
    const specialExtensions: string[] = ['.rar'];
    return specialExtensions.some((ext) => fileName.endsWith(ext) || fileName.includes(ext));
}